import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
// import Paper from '@material-ui/core/Paper';
import Immutable from 'immutable';

import { AutoSizer, Column, Table } from 'react-virtualized';
import { get } from 'lodash-es';

import SortDirection from './SortDirection';

import './CoogTable.scss';

// import { ContentBox, ContentBoxHeader, ContentBoxParagraph } from './ContentBox';

class CoogTable extends PureComponent {
  // eslint-disable-next-line react/sort-comp
  static SortDirection = SortDirection;

  constructor(props) {
    super(props);

    this.state = {
      columns: props.columns,
      rows: props.rows,
      sortedRows: props.rows,
      sortBy: undefined,
      sortDirection: SortDirection.ASC,
      uid: props.uid,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static getDerivedStateFromProps(nextProps, prevState) {
    const { rows: nextRows } = nextProps;
    const { rows: prevRows } = prevState;
    let newState = null;

    if (nextRows && !!nextRows.toJS && !Immutable.is(prevRows, nextRows)) {
      newState = {
        rows: nextRows,
      };
    }
    // TODO: add columns...

    return newState;
  }

  componentDidMount() {
    const { sortBy, sortDirection } = this.state;
    const { defaultSorted } = this.props;
    this.rowSort({
      sortBy: defaultSorted.sortBy || sortBy,
      sortDirection: defaultSorted.sortDirection || sortDirection,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const self = this;
    const { sortBy, sortDirection, rows } = self.state;
    const { rows: prevRows } = prevState;

    if (rows && !!rows.toJS && !Immutable.is(rows, prevRows)) {
      self.rowSort({ sortBy, sortDirection, forced: true });
    }
  }

  rowSort = ({ sortBy, sortDirection, forced }) => {
    const { sortBy: prevSortBy, sortDirection: prevSortDirection } = this.state;
    const { rows } = this.props;
    // If list was sorted DESC by this column.
    // Rather than switch to ASC, return to "natural" order.
    if (sortBy !== prevSortBy || sortDirection !== prevSortDirection || forced) {
      if (prevSortDirection === SortDirection.DESC && !forced) {
        this.setState({ sortBy: undefined, sortDirection: undefined });
        this.setState({ sortedRows: rows });
      } else {
        this.setState({ sortBy, sortDirection });
        if (sortBy) {
          const sortedRows = rows.sortBy(item => item.get(sortBy));
          if (sortDirection === SortDirection.DESC) {
            this.setState({ sortedRows: sortedRows.reverse() });
          } else {
            this.setState({ sortedRows });
          }
        }
      }
    }
  };

  // eslint-disable-next-line no-unused-vars
  handleOnClick = ({ route, action, type, id }) => {
    const { onClickCellAction } = this.props;
    onClickCellAction({ route, type, id });
  };

  // eslint-disable-next-line no-unused-vars
  columnCellRenderer = ({ rowData, cellData, rowIndex }) => {
    const { strings } = this.props;
    const { uid } = this.state;

    const getIcon = action => {
      switch (action.get('action')) {
        case 'modify':
          return <EditIcon fontSize="small" />;
        case 'cancel':
          return <DeleteIcon fontSize="small" />;
        case 'view':
          return <RemoveRedEyeIcon fontSize="small" />;
        case 'link':
          return <OpenInNewIcon fontSize="small" />;

        default:
          return strings[action.get('label')];
      }
    };
    const getColor = action => {
      switch (action.get('action')) {
        case 'modify':
          return 'primary';
        case 'cancel':
          return 'secondary';
        case 'view':
          return 'primary';
        case 'link':
          return 'primary';

        default:
          return 'primary';
      }
    };
    const actions = [];
    try {
      cellData.forEach(action => {
        actions.push(
          <IconButton
            size="small"
            key={`${action.get('route')}-${rowData.get(uid)}`}
            label={strings[action.get('label')]}
            aria-label={strings[action.get('label')]}
            color={getColor(action)}
            onClick={() =>
              this.handleOnClick({
                route: action.get('route'),
                type: action.get('type'),
                action: action.get('action'),
                id: rowData.get(uid),
              })
            }
            onTouchEnd={() =>
              this.handleOnClick({
                route: action.get('route'),
                type: action.get('type'),
                id: rowData.get(uid),
              })
            }
          >
            {/* {strings[action.get('label')]} */}
            {getIcon(action)}
          </IconButton>
        );
      });
    } catch (e) {
      actions.push(`Invalid link: ${e}`);
    }

    return <>{actions}</>;
  };

  render() {
    const { sortedRows, columns, sortBy, sortDirection } = this.state;
    const { strings } = this.props;

    const getColumn = column => {
      switch (column.type) {
        case 'link':
          return (
            <Column
              key={column.name}
              label={column.label}
              dataKey={column.name}
              width={column.width}
              flexGrow={1}
              cellRenderer={this.columnCellRenderer}
            />
          );

        case 'rendered':
          return (
            <Column
              key={column.name}
              label={column.label}
              dataKey={column.name}
              width={column.width}
              flexGrow={1}
              cellRenderer={column.render}
            />
          );

        default:
          return (
            <Column key={column.name} label={column.label} dataKey={column.name} width={column.width} flexGrow={1} />
          );
      }
    };

    const getHeaders = () => columns.map(column => getColumn(column));
    const table = (
      <AutoSizer key="coogtable.autosizer">
        {({ height, width }) => (
          <Table
            headerHeight={30}
            height={height}
            rowCount={sortedRows.size}
            columnCount={5}
            rowGetter={({ index }) => sortedRows.get(index)}
            rowHeight={50}
            width={width}
            sort={this.rowSort}
            sortBy={sortBy}
            sortDirection={sortDirection}
          >
            {getHeaders()}
          </Table>
        )}
      </AutoSizer>
    );

    const emptyMessage = (
      <div className="coog-table__message" key="coogtable.empty.message">
        {get(strings, 'coogtable.empty.message', 'No entry found')}
      </div>
    );
    const badConfigMessage = (
      <div className="coog-table__message" key="coogtable.badconfig.message">
        {get(strings, 'coogtable.badconfig.message', 'Wrong columns configuration')}
      </div>
    );
    const content = [];
    if (columns && columns.length > 0) {
      content.push(table);
      if (sortedRows && sortedRows.size === 0) {
        content.push(emptyMessage);
      }
    } else {
      content.push(badConfigMessage);
    }
    return <>{content}</>;
  }
}

CoogTable.propTypes = {
  rows: PropTypes.instanceOf(Immutable.List),
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      label: PropTypes.string,
      width: PropTypes.number,
    })
  ).isRequired,
  defaultSorted: PropTypes.shape({
    sortBy: PropTypes.string,
    sortDirection: PropTypes.string,
  }),
  uid: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  strings: PropTypes.object.isRequired,
  onClickCellAction: PropTypes.func,
};
CoogTable.defaultProps = {
  rows: Immutable.fromJS([]),
  defaultSorted: { sortBy: undefined, sortDirection: undefined },
  onClickCellAction: params => params,
};

export default CoogTable;
